import * as req from 'api/actions';
import * as c from './constant';

export const getTaxRevenueTypesList = (
  payload = { sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_TAX_REVENUE_TYPES,
    '/api/v1/bpls/administrator/tax_revenue_types',
    payload,
    callback
  );

export const getSingleTaxRevenueTypes = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_TAX_REVENUE_TYPES,
    `/api/v1/bpls/administrator/tax_revenue_types/${id}`,
    payload,
    callback
  );

export const createTaxRevenueTypes = (payload, callback) =>
  req.create(
    c.CREATE_TAX_REVENUE_TYPES,
    '/api/v1/bpls/administrator/tax_revenue_types',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateTaxRevenueTypes = (id, payload, callback) =>
  req.update(
    c.UPDATE_TAX_REVENUE_TYPES,
    `/api/v1/bpls/administrator/tax_revenue_types/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

// export const removeTaxRevenueTypes = (id, payload, callback) =>
//   req.remove(
//     c.REMOVE_TAX_REVENUE_TYPES,
//     `/api/v1/bpls/administrator/tax_revenue_types/${id}`,
//     payload,
//     callback
//   );
